import * as actions from "./customers.types";

export const handleGetCustomers = ( {locationId,customerNumber, callback}): actions.HandleGetCustomers => {
    return {
        type: actions.HANDLE_GET_CUSTOMERS,
         payload: {locationId,customerNumber,callback}
    };
};